export const routes = [
  {
    path: "/suporte",
    component: () =>
      import(/* webpackChunkName: "support" */ "./pages/SupportPage.vue"),
    name: "support.open",
  },
];
